import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { BUS_AIRCRAFT_CODE } from '@fcom/common-booking/interfaces';

import { Airport } from '../interface';

/**
 * @Unstable
 * Warning! This component is in active development and is not production ready.
 *
 * Documentation can be found in `storybook/stories/flights/timeline.stories.mdx`
 */
@Component({
  selector: 'fcom-timeline',
  templateUrl: './timeline.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimelineComponent implements OnInit {
  /**
   * Object containing the information for the Departure airport, including
   * - city name
   * - airport name
   * - airport code
   * - formatted dateTime of departure @example "08:45 Thu"
   *
   * Required
   */
  @Input({ required: true }) departure: Airport;

  /**
   * Object containing the information for the Arrival airport, including
   * - city name
   * - airport name
   * - airport code
   * - formatted dateTime of arrival @example "08:45 Thu"
   *
   * Required
   */
  @Input({ required: true }) arrival: Airport;

  @Input() isByBusOnly = false;

  departureIcon: string;
  arrivalIcon: string;

  ngOnInit(): void {
    this.departureIcon = this.isByBusOnly ? BUS_AIRCRAFT_CODE.toLowerCase() : 'departure';
    this.arrivalIcon = this.isByBusOnly ? BUS_AIRCRAFT_CODE.toLowerCase() : 'arrival';
  }
}
